// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_j9-0";